import {connect} from 'react-redux';
import {push} from 'react-router-redux/lib/actions';
import {STREAM_ROUTER_VOD} from '../constants';
import CreateNewComponent from './VideoOnDemandEdit';
import {vodAction} from '../../../../actions/vod';

// new way of actions. Has to have less memory in use;
let CRUDActions = vodAction;

export default connect(
  ({vod: {loadingItem, model}}) => ({
    model,
    title: 'Edit Video on Demand',
    loading: loadingItem
  }),
  dispatch => ({
    fetch: (id) => dispatch(CRUDActions.fetch(id)),
    goIndex: () => dispatch(push(STREAM_ROUTER_VOD))
  })
)(CreateNewComponent)





// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/VideoOnDemandEdit/index.js